import React from 'react';
import { LTLoader } from '@lambdatestincprivate/lt-components';
import styles from './loading-journey.module.css';

/**
 * The ONE loading visual for the whole evidence journey — LTLoader under a
 * stage label. Every wait state renders this same component with a
 * different stage, so a reload reads as one continuous journey instead of
 * three unrelated spinners:
 *
 *   host mint  → "Preparing your evidence…"
 *   pack open  → "Opening evidence pack…"
 *   hydration  → "Reading failure analysis…"
 */
import { jsx as _jsx } from "react/jsx-runtime";
export function LoadingJourney(_ref) {
  var _styles$variant;
  var stage = _ref.stage,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'bare' : _ref$variant;
  return /*#__PURE__*/_jsx("div", {
    className: "".concat(styles.wrap, " ").concat((_styles$variant = styles[variant]) !== null && _styles$variant !== void 0 ? _styles$variant : ''),
    children: /*#__PURE__*/_jsx(LTLoader, {
      description: stage,
      size: variant === 'compact' ? LTLoader.SpinnerSizes.MEDIUM : LTLoader.SpinnerSizes.LARGE
    })
  });
}